module.exports = __webpack_public_path__ + "img/23.5c1cbf4.jpg";